export default __webpack_public_path__ + "static/media/etapa4.5dd7118a.png";